// Vendors
import $ from 'jquery';
import { AJAX_URL } from '../config';
import modals from '../framework/modal';

// Init modals
modals('[data-modal]');

const $signUpModal = $('[data-modal="modal-subscribe-to-newsletter"]');
const hideModalCookie = localStorage.getItem('hide-subscribe-modal');
let modalTimeout = false;
let scrollLimit = false;
let alreadyShown = false;

$(document).ready(function () {
  if (hideModalCookie == null && !document.body.classList.contains('no-subscribe-modal')) {
    startModalTimer();
    startTrackingScroll();
  }
});

// Save Cookie Once Modal Hides
$signUpModal.on('modal:afterHide', (event) => {
  saveHideModalCookie();
});

const maybeShowModal = () => {
  if (!alreadyShown && (modalTimeout || scrollLimit)) {
    alreadyShown = true;
    showSignUpModal();
  }
};

const showSignUpModal = () => {
  $signUpModal.trigger('modal:show');
  $('html').removeClass('html--modal-visible');
};

const hideSignUpModal = () => $signUpModal.trigger('modal:hide');

const saveHideModalCookie = () =>
  localStorage.setItem('hide-subscribe-modal', 1);

const startModalTimer = () =>
  setTimeout(() => {
    modalTimeout = true;
    maybeShowModal();
  }, 10000);

const startTrackingScroll = () =>
  window.addEventListener('scroll', checkPageScrolledAmount, false);

//Get the scroll page percentage
const getScrollHeight = () => {
  return Math.max(
    document.body.scrollHeight,
    document.documentElement.scrollHeight,
    document.body.offsetHeight,
    document.documentElement.offsetHeight,
    document.body.clientHeight,
    document.documentElement.clientHeight
  );
};

const checkPageScrolledAmount = () => {
  const docHeight = getScrollHeight();
  const percentageScrolledToShow = 25;
  let winheight =
    window.innerHeight ||
    (document.documentElement || document.body).clientHeight;
  let scrollTop =
    window.pageYOffset ||
    (document.documentElement || document.body.parentNode || document.body)
      .scrollTop;
  let trackLength = docHeight - winheight;
  let pageScrolled = Math.floor((scrollTop / trackLength) * 100); // gets percentage scrolled (ie: 80 or NaN if tracklength == 0)

  if (pageScrolled === percentageScrolledToShow && !scrollLimit) {
    scrollLimit = true;
    maybeShowModal();
  }
};

// Handle Form Submission
$('form#subscribe-to-newsletter').on('submit', (event) => {
  event.preventDefault();

  // Setup Consts
  const $userEmailInputField = $("input[name='signup-email']");
  const $userFnameInputField = $("input[name='signup-fname']");
  const $userLnameInputField = $("input[name='signup-lname']");
  const $userNewslettersInputFields = $('.form__checkbox');
  const $userNotice = $('.notice');

  const userEmail = $userEmailInputField.val();
  const userFname = $userFnameInputField.val();
  const userLname = $userLnameInputField.val();
  let newsletter_values = $('.newsletters:checkbox:checked')
    .map(function () {
      return this.value;
    })
    .get();

  // Remove Validation Errors
  $('input').removeClass('validation-error');
  $userNewslettersInputFields.removeClass('validation-error');

  let valid = true;
  if (!userEmail) {
    $userEmailInputField.addClass('validation-error');
    valid = false;
  }
  if (!userFname) {
    $userFnameInputField.addClass('validation-error');
    valid = false;
  }
  if (!userLname) {
    $userLnameInputField.addClass('validation-error');
    valid = false;
  }
  if (newsletter_values.length === 0) {
    $userNewslettersInputFields.addClass('validation-error');
    valid = false;
  }

  if (!valid) {
    return;
  }

  $.ajax({
    type: 'POST',
    url: `${AJAX_URL}wl_subscribe_user`,
    dataType: 'json',
    encode: true,
    data: {
      email: userEmail,
      firstName: userFname,
      lastName: userLname,
      newsletters: newsletter_values
    },
    success: (res) => {
      $userNotice.html(res.data.message);
      $userNotice.removeClass('u--display-none');

      if (res.success) {
        $userNotice.addClass('notice--green');
        setTimeout(() => {
          saveHideModalCookie();
          hideSignUpModal();
          window.removeEventListener('scroll', checkPageScrolledAmount, false);
        }, 5000);
      } else {
        $userNotice.addClass('notice--red');
      }
    }
  });
});
